import { list } from "postcss";
import Request from "./index";

// export const findBusinesses = async (data) => {
//   return new Promise((resolve, reject) => {
//     Request.post("/findBusinesses", data)
//       .then((res) => {
//         resolve(res);
//       })
//       .catch((err) => {
//         reject(err);
//       });
//   });
// };
// export const updateColdCallsUsed = async (coldCallsUsed) => {
//   return new Promise((resolve, reject) => {
//     Request.post("/updateColdCallsUsed", { coldCallsUsed: coldCallsUsed })
//       .then((res) => {
//         resolve(res);
//       })
//       .catch((err) => {
//         reject(err);
//       });
//   });
// };

export const initializeUserCredits = async () => {
  return new Promise((resolve, reject) => {
    Request.get("/initializeUserCredits")
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getUserCredits = async () => {
  return new Promise((resolve, reject) => {
    Request.get("/getUserCredits")
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// API call to upload an image
export const uploadFurnishHomeImage = async (data) => {
  return new Promise((resolve, reject) => {
    Request.post("/uploadFurnishHomeImage", data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const uploadRemoveFurnitureImage = async (data) => {
  return new Promise((resolve, reject) => {
    Request.post("/uploadRemoveFurnitureImage", data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// API call to generate a furnished image
export const generateFurnishedImage = async (data) => {
  return new Promise((resolve, reject) => {
    Request.post("/generateFurnishedImage", data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const generateImageVariation = async (data) => {
  return new Promise((resolve, reject) => {
    Request.post("/generateImageVariation", data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const removeFurniture = async (data) => {
  return new Promise((resolve, reject) => {
    Request.post("/generateDeclutteredImage", data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getFurnishImageHistory = async () => {
  return new Promise((resolve, reject) => {
    Request.get("/getFurnishImageHistory")
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getDeclutteredImageHistory = async () => {
  return new Promise((resolve, reject) => {
    Request.get("/getDeclutteredImageHistory")
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
